import(/* webpackMode: "eager", webpackExports: ["Root","Viewport","Corner"] */ "/opt/buildhome/repo/node_modules/@radix-ui/react-scroll-area/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/opt/buildhome/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Rajdhani\",\"arguments\":[{\"weight\":[\"500\",\"700\"],\"style\":\"normal\",\"subsets\":[\"latin\"]}],\"variableName\":\"rajdhani\"}");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/buildhome/repo/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/index.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/filters-store-router.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/search-store-router.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/setup-search-callback.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/ui/footer.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderRuntime"] */ "/opt/buildhome/repo/src/components/ui/header-runtime.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollBar"] */ "/opt/buildhome/repo/src/components/ui/scroll-area.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/webapp-page-load-performance.tsx");
